import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import SeoHeaders from "../components/seoheaders";
import * as wActs from "../actions/website-actions";
import * as lActs from "../actions/links-actions";
import * as wConsts from "../consts/website-consts";
import {Link} from "react-router-dom";
import SideBanners from "../components/sidebanners";
import PerfectScrollbar from 'react-perfect-scrollbar'
//import Disqus from 'disqus-react';
import LinkButtons from "../components/linkbuttons";

class LinkPage extends Component {



  constructor(props) {
    super(props);
    this.state = {
      Username: "", Password: "", RememberMe: false,

    };
    this.props.dispatch({ type: wConsts.ACTION_SET_PAGETYPE, payload: "link" });
  }

  componentDidMount() {
    if(typeof window !== "undefined") {
      console.log(wActs.getCookie(wActs.lsKey));
    }
  }

  getTranslation(key)
  {
    return this.props.WebPage.Translations[key];
  }

  getSimpleUrl(url) {
    let uri = new URL(url);
    return uri.hostname.replace("www.","");
  }


  render() {
    let status = this.props.WebPage.User.LoginStatus;
    let centerBan = "four-center-banner" + wActs.MainLeftStyle(this.props.WebPage);

    if(!this.props.Link.Loaded) {
      return (
        <div>
          <SeoHeaders Position={"Top"}/>
          <div className="row">
            <div className={"col_80"}>
              <div className="white-box the-content">
                <p style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <img src="/imgs/loader.gif" alt={"Loader"}/>
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }


    let link = this.props.Link.ApiResult.Result;
    let cnt = 0;
    let disqusShortname = "";
    let disqusConfig = {}
    if(typeof window !== "undefined") {
      disqusShortname = "escortdude";
      disqusConfig = {
        language: this.props.WebPage.Settings.SelectedLocal == "/" ? "en" : this.props.WebPage.Settings.SelectedLocal,
        url: link.Url,
        identifier: `link-${link.Id}`,
        title: link.Title,
      };
      console.log(disqusConfig);
    }


    let iUrl = "";
    if(link.Screenshot) {
      iUrl = link.Screenshot.Url;
    }
    if(link.ImageType.Value == "Image") {
      iUrl = link.Image.Url;
    }
    iUrl = iUrl.replace("source","400x400");
    let sPromo = true;
    return (
      <div>
        <SeoHeaders Position={"Top"}/>
        <div className="row">
          <div className={"col_80"}>
            <div className="white-box the-content">
              <div className="row">
                <div className="cell x6">
                  {link.Visible &&
                  <a href={link.TargetUrl} rel={link.NoFollow ? "nofollow" : ""}  title={link.Title} target={"_blank"}><img src={iUrl} style={{width: "100%"}} alt={link.Name}/></a>
                  }
                  {!link.Visible &&
                  <img src={iUrl} style={{width: "100%"}} alt={link.Name}/>
                  }

                </div>
                <div className="cell x6 link-left-side">
                  <h2 style={{marginBottom: "2px", fontSize: "14px", fontWeight: "bold", lineHeight: "14px", paddingLeft: "4px"}}>{link.Title}</h2>
                  <div style={{fontSize: "10px", color: "#ccc", paddingLeft: "5px"}}><a style={{fontSize: "12px", color: "#ccc"}} href={link.TargetUrl} target="_blank">{this.getSimpleUrl(link.TargetUrl)}</a></div>
                  <div className="clear"></div>

                  <div className="row">
                    <div className="cell x12 link-description-text">
                      <pre>{link.Description}</pre>
                    </div>
                  </div>


                  <PerfectScrollbar className="link-summary-text">
                    {wActs.isNullOrEmpty(link.Summary) &&
                    <div dangerouslySetInnerHTML={{__html: this.getTranslation("page.nostorytosharewithyou").replace("{{Name}}",link.Name).replace("{{ContactUrl}}", wActs.getCultPath(this.props.WebPage,"/support"))}}></div>
                    }
                    {!wActs.isNullOrEmpty(link.Summary) &&
                    <pre>{link.Summary}</pre>
                    }

                  </PerfectScrollbar>
                </div>
              </div>

              <div className="row" style={{marginTop: "40px"}}>
                <div className="cell x12 flex-center">
                  {link.Tags.map((v)=>{
                    return <span className="link-tag">{v.Name}</span>
                  })}
                </div>
              </div>

              {sPromo && <LinkButtons BannersInc={this.props.BannersInc} ContainerClass={"linkpage-link-buttons-container"} BannersLoader={this.props.BannersLoader} Zone={"promo-button-88x32"} /> }

              <div className="row" style={{marginTop: "40px"}}>
                {link.Visible &&
                <div className="cell x12">
                  {link.NoFollow &&
                  <a href={link.TargetUrl} target="_blank" title={link.Title} rel="nofollow" className="link-visit-website"><i className="fa fa-link" style={{marginRight: "10px"}}></i>{link.Name}</a>
                  }
                  {!link.NoFollow &&
                  <a href={link.TargetUrl} target="_blank" title={link.Title} className="link-visit-website"><i className="fa fa-link" style={{marginRight: "10px"}}></i>{link.Name}</a>
                  }
                </div>
                }
              </div>

              <div className="row" style={{marginTop: "40px"}}>
                <div className="cell x12 trans-help">
                  {typeof window !== "undefined" &&
                    <span dangerouslySetInnerHTML={{__html: this.getTranslation("page.helptranslate").replace("{{ContactUrl}}", wActs.getCultPath(this.props.WebPage,"/support"))}}></span>
                  }
                </div>
              </div>


              <div className="row" style={{marginTop: "40px"}}>
                <div className="cell x12" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                  <img src="/imgs/face.png" style={{width: "50px"}} alt={this.props.WebPage.Settings.SeoName}/><span style={{fontSize: "16px", marginLeft: "20px"}} >{this.getTranslation("page.checkoutthisgreatothersites")}</span>
                </div>
              </div>



              <div className="section top-results">
              <div className="boxes">
                {!this.props.SubLinks.Loaded &&
                <div className="cell x12" style={{display: "flex", justifyContent: "center"}}><img src="/imgs/loader.gif" style={{margin: "10px auto"}} alt={"Loading"}/></div>
                }
                {this.props.SubLinks.Loaded &&
                <React.Fragment>
                  {this.props.SubLinks.ApiResult.Result.map((v,i) => {
                    let pge = 1;
                    let idx = cnt+1;
                    if(idx>12) {return null;}
                    if(v.Id == link.Id) {return null;}
                    cnt++;
                    let url = v.TargetUrl; //Go Right To Link, _blank
                    if(v.Blog) { //No Page, But Blog
                      let uri = new URL(v.Blog.Url);
                      url = uri.pathname + (uri.search.length>0 ? uri.search : "");
                    }
                    if(v.Page) { //Page Always Overides Last ...
                      url = wActs.getCultPath(this.props.WebPage, `/${v.Page.Slug}-${v.Id}`);
                    }

                    let inBox = (
                      <div className="box">
                        <div className="title">
                          <h3 style={{overflow:"hidden", height: "25px"}}>{v.Name}</h3>
                          <p style={{overflow:"hidden", height: "55px"}}>{v.Title}</p>
                        </div>
                        <img src={v.PreviewImageUrl.replace("preview","300x300")} alt={v.Name}/>
                      </div>
                    );

                    if(url.startsWith("http")) {
                      return (<a title={v.Title} href={url} target={"_blank"} key={"featured-" + i} className="cell x3" style={{cursor: "pointer"}}>{inBox}</a>);
                    } else {
                      return (<Link title={v.Title} to={url} key={"featured-" + i} className="cell x3" style={{cursor: "pointer"}}>{inBox}</Link>);
                    }
                  })}
                </React.Fragment>
                }
              </div>
              </div>

          </div>
          </div>
          <SideBanners BannersInc={this.props.BannersInc} BannersLoader={this.props.BannersLoader} count={"5"}/>
        </div>
      </div>
    );
  }

  componentDidUpdate(pProps,pState) {
    if(this.props.Link.Loaded) {
      if(!this.props.SubLinks.Loaded && !this.props.SubLinks.Loading) {
        let city="";
        try {
          if(!wActs.isNullOrUndefined(this.props.WebPage.Page.Template.City)) {
            city = this.props.WebPage.Page.Template.City.Value;
          }
        } catch(ex) {}
        this.props.dispatch(lActs.getSubLinks("",this.props.Link.ApiResult.Result.Country.Code,this.props.Link.ApiResult.Result.Category.Id,city));
      }
    }
  }

}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Link: state.Links.Link,
    SubLinks: state.Links.SubLinks,
    BannersLoader: state.Ads.BannersLoader,
    BannersInc: state.Ads.BannersInc
  };
};

export default connect(mapStateToProps)(LinkPage);
